module.exports = __webpack_public_path__ + "static/media/FrozenBackground.05db0fa0.png";